import {inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {LoadingService} from "../services/commons/loading.service";
import {ErrorService} from "../services/commons/error.service";
import {MessageService} from "primeng/api";
import {MsalService} from "@azure/msal-angular";
import {Router} from "@angular/router";
import {isPlatformBrowser} from "@angular/common";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public messageService = inject(MessageService)
  public loadingService = inject(LoadingService)
  private errorService = inject(ErrorService)
  public router = inject(Router)
  private msalService = inject(MsalService)
  private platformId = inject(PLATFORM_ID)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (request.url.includes('/sirene/')) return [];
          if (request.url.includes('login.microsoftonline.com')) return [];
          if (request.headers.has('x-current-loading')) {
            this.loadingService.currentLoading.update(()=>this.loadingService.currentLoading().filter(x => x !== request.headers.get('x-current-loading')));
          }

          let errorMessage: string = err.error?.['description'] || err.error?.detail || err.error?.error || err.message || err.toString();

          if (err.status !== 0 && isPlatformBrowser(this.platformId)) {
            this.errorService.serverErrors.update(()=>[errorMessage]);
            if (this.router.url.includes('/admin'))  {
              this.messageService.add({severity: 'error', summary: 'Erreur server', detail: errorMessage});
            }
          }

          if (err.status === 401 && isPlatformBrowser(this.platformId) && this.router.url.includes('/admin')) {
            this.msalService.logout();
          }

          return [];
        })
      );
  }
}
